import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { getAlert, deleteAlert } from "../../../../redux/educator/actions";
import {
  selectAlerts,
  selectAlertsLoaded,
  selectAlertsLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  alerts: selectAlerts(state),
  loading: selectAlertsLoading(state),
  loaded: selectAlertsLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getAlert,
      deleteAlert,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
